import { Text, type TextTags, type TextOwnProps } from '../Text';

export interface BodyTextProps extends Omit<TextOwnProps, 'variant'> {
  /**
   * The content of the component
   */
  children: React.ReactNode;
  /**
   * It defines the HTML tag that will be rendered
   */
  as?: TextTags;
}

/**
 * The Body Text components render text with the paragraph styles and are more commonly used.
 */
export const P0: React.FC<BodyTextProps> = ({
  children,
  as = 'p',
  textOverflowEllipsis = false,
  ...rest
}) => {
  return (
    <Text
      as={as}
      textOverflowEllipsis={textOverflowEllipsis}
      variant="p0"
      {...rest}
    >
      {children}
    </Text>
  );
};

export const P1: React.FC<BodyTextProps> = ({
  children,
  as = 'p',
  textOverflowEllipsis = false,
  ...rest
}) => {
  return (
    <Text
      as={as}
      textOverflowEllipsis={textOverflowEllipsis}
      variant="p1"
      {...rest}
    >
      {children}
    </Text>
  );
};

export const P2: React.FC<BodyTextProps> = ({
  children,
  as = 'p',
  textOverflowEllipsis = false,
  ...rest
}) => {
  return (
    <Text
      as={as}
      textOverflowEllipsis={textOverflowEllipsis}
      variant="p2"
      {...rest}
    >
      {children}
    </Text>
  );
};

export const P3: React.FC<BodyTextProps> = ({
  children,
  as = 'p',
  textOverflowEllipsis = false,
  ...rest
}) => {
  return (
    <Text
      as={as}
      textOverflowEllipsis={textOverflowEllipsis}
      variant="p3"
      {...rest}
    >
      {children}
    </Text>
  );
};

export const P4: React.FC<BodyTextProps> = ({
  children,
  as = 'p',
  textOverflowEllipsis = false,
  ...rest
}) => {
  return (
    <Text
      as={as}
      textOverflowEllipsis={textOverflowEllipsis}
      variant="p4"
      {...rest}
    >
      {children}
    </Text>
  );
};
